﻿import { initGoogleMap } from "@/StoreMap"

window.addEventListener("load", () => {
    initGoogleMap();
});